import BoxWithLogo from "@/components/logoBox";
import { WHY_ONEMIND_CONSTANTS } from "./constants";

const WhyOneMind = () => {
  return <BoxWithLogo {...WHY_ONEMIND_CONSTANTS} />;
};

export default WhyOneMind;
